import React from 'react';
import { useTranslation } from 'react-i18next';
import { ConferenceParty } from '../../types';
import { formatPhoneForDisplay } from '../../utils/format-phone.util';
import styles from './ConferenceParticipants.module.css';

interface ConferenceParticipantListPopupProps {
  parties: ConferenceParty[];
  onClose: () => void;
}

export function ConferenceParticipantListPopup({
  parties,
  onClose,
}: ConferenceParticipantListPopupProps) {
  const { t } = useTranslation();

  return (
    <div className={styles.participantListPopup}>
      <div className={styles.participantListHeader}>
        <span>{t('call:participants.conferenceParticipants')}</span>
        <button className={styles.participantListClose} onClick={onClose} type="button">
          <svg viewBox="0 0 24 24" width="16" height="16" fill="currentColor">
            <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" />
          </svg>
        </button>
      </div>
      <ul className={styles.participantList}>
        {parties.map((party) => (
          <li key={party.partyId} className={styles.participantItem}>
            <div className={styles.participantAvatar}>
              {party.partyType === 'agent' ? (
                <svg viewBox="0 0 24 24" width="16" height="16" fill="currentColor">
                  <path d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z" />
                </svg>
              ) : party.partyType === 'customer' ? (
                <svg viewBox="0 0 24 24" width="16" height="16" fill="currentColor">
                  <path d="M6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1.02l-2.2 2.2z" />
                </svg>
              ) : (
                <svg viewBox="0 0 24 24" width="16" height="16" fill="currentColor">
                  <path d="M20 15.5c-1.25 0-2.45-.2-3.57-.57-.1-.03-.21-.05-.31-.05-.26 0-.51.1-.71.29l-2.2 2.2c-2.83-1.44-5.15-3.75-6.59-6.59l2.2-2.21c.28-.26.36-.65.25-1C8.7 6.45 8.5 5.25 8.5 4c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1 0 9.39 7.61 17 17 17 .55 0 1-.45 1-1v-3.5c0-.55-.45-1-1-1z" />
                </svg>
              )}
            </div>
            <div className={styles.participantInfo}>
              <span className={styles.participantName}>
                {party.phoneNumber && party.name === party.phoneNumber
                  ? formatPhoneForDisplay(party.name)
                  : party.name}
              </span>
              <span className={styles.participantType}>
                {party.partyType === 'agent'
                  ? t('call:participants.agent')
                  : party.partyType === 'customer'
                    ? t('call:participants.customer')
                    : t('call:participants.external')}
                {party.phoneNumber &&
                  party.name !== party.phoneNumber &&
                  ` - ${formatPhoneForDisplay(party.phoneNumber)}`}
              </span>
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
}
